import { Client } from "@/shared/services/client"
import Crud from "@/shared/services/crud"
import { TableQueryParams } from "@/shared/models/table-query-params"
import { PagedResponse } from "@/shared/models/paged-response"
import { MarketingCampaign } from "@/shared/models/marketing-campaign"

const client = new Client()

export class MarketingCampaignService extends Crud<MarketingCampaign> {
    constructor() {
        super("crm/marketing-campaign")
    }

    getAll(queryParams: TableQueryParams): Promise<PagedResponse<MarketingCampaign>> {
        return client.get(this.endpoint, { params: queryParams })
    }

    checkMarketingCampaignList(typeName: string, entityIds: string[]) {
        return client.get(`${this.endpoint}/listCheck`, { params: { typeName, entityIds } })
    }
}
